import { getDateHeader } from '../../utils/timelineHelpers';
import { COLORS, TYPOGRAPHY, SPACING } from '../../constants/theme';

const DateSectionHeader = ({ date }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: SPACING.XL,
        marginTop: SPACING.XL,
        marginLeft: '48px',
        gap: SPACING.LG
      }}
    >
      <div
        style={{
          height: '1px',
          backgroundColor: COLORS.GRAY_BORDER_DARK,
          flex: 1
        }}
      />
      <span
        style={{
          fontSize: '15px',
          color: COLORS.GRAY_MEDIUM,
          fontWeight: '500',
          whiteSpace: 'nowrap'
        }}
      >
        {getDateHeader(date)}
      </span>
      <div
        style={{
          height: '1px',
          backgroundColor: COLORS.GRAY_BORDER_DARK,
          flex: 1
        }}
      />
    </div>
  );
};

export default DateSectionHeader;
